export const generateId = (prefix) => {
  let generatedId = Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)

  if (prefix) {
    return `${prefix}-${generatedId}`
  }
  return generatedId
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/generateId.js